import { isToday, parseISO } from 'date-fns'
import { ImCheckboxUnchecked } from 'react-icons/im'
import { TiInputChecked } from 'react-icons/ti'
import { Link } from 'react-router-dom'

import { Badge } from '../../../../components/Badge'
import { usePermission } from '../../../../hooks/usePermission'
import { ProductProblem, productProblemsMap } from '../../../../interfaces/productProblemsEnum'
import { cn } from '../../../../libs/tailwindMerge'
import { CleanReport } from '../../../../services/reportServices'

interface DailyReportCardProps {
  report: CleanReport
  handleToggleTradeMarketingDailyCheck: (reportId: string) => Promise<void>
}

export function DailyReportCard({ report, handleToggleTradeMarketingDailyCheck }: DailyReportCardProps) {
  const { canToggleTradeMarketingDailyCheck } = usePermission()

  const tradeMarketingCheckDate = report.trade_marketing_check_date

  const isTradeMarketingCheckDateToday = tradeMarketingCheckDate
    ? isToday(typeof tradeMarketingCheckDate === 'string'
      ? parseISO(tradeMarketingCheckDate)
      : tradeMarketingCheckDate)
    : false

  function defineAlertBadges() {
    const getPoductBadgeTitle = (values: ProductProblem[]) => {
      const problems: string[] = []
      values.forEach(item => {
        if (!problems.includes(productProblemsMap[item])) {
          problems.push(productProblemsMap[item])
        }
      })

      return problems.join(' - ')
    }

    if (report.report_product_problem.length === 0 && !report.has_promoter_problem) {
      return (
        <Badge status={false} title="Tudo ok" />
      )
    } else {
      return (
        <>
          {report.has_promoter_problem &&
            <Badge status={report.has_promoter_problem} title="Promotor" />}
          {report.report_product_problem.length > 0 &&
            <Badge
              status={report.report_product_problem.length > 0}
              title={getPoductBadgeTitle(report.report_product_problem.map(item => item.problem))}
            />}
        </>
      )
    }
  }
  return (
    <div className="flex flex-col border rounded-sm bg-white shadow-sm">
      <header className="flex justify-between items-stretch">
        <div className="flex flex-col p-4">
          <Link to={`/reports/${report.id}`} className="flex flex-row gap-2">
            <img
              src={report.store.group.logo_url}
              className="w-6 h-6 md:w-8 md:h-8 object-cover rounded-md border"
            />
            <strong className="text-lg md:text-2xl text-slate-900">
              {report.store.name}
            </strong>
          </Link>
          <span
            className="text-slate-700 font-semibold mt-4"
          >
            {report.store.city} - {report.store.state}
          </span>
        </div>
        <div className="flex">
          <div className="flex flex-col items-end space-y-2 py-4">
            {defineAlertBadges()}
          </div>
          <button
            className={cn(
              'px-4 ml-4 rounded-sm transition-colors min-w-[57px] text-center disabled:opacity-50',
              isTradeMarketingCheckDateToday
                ? 'bg-green-200 hover:bg-green-300 disabled:hover:bg-green-200'
                : 'bg-orange-200 hover:bg-orange-300 disabled:hover:bg-orange-200',
            )}
            type="button"
            title={!isTradeMarketingCheckDateToday
              ? 'Marcar como verificado'
              : 'Marcar como não verificado'}
            onClick={() => handleToggleTradeMarketingDailyCheck(report.id)}
            disabled={!canToggleTradeMarketingDailyCheck}
          >
            <span className="inline-block align-middle">
              {isTradeMarketingCheckDateToday
                ? (
                  <TiInputChecked size={25} />
                  )
                : (
                  <ImCheckboxUnchecked size={15} />
                  )}
            </span>
          </button>
        </div>
      </header>
    </div>
  )
}
